import { createSlice } from '@reduxjs/toolkit';

export const playerSlice = createSlice({
  name: 'player',
  initialState: {
    currentStation: {
      Id: '0',
      IsActive: true,
      IsPlaying: false,
      LastListened: null,
      Favorite: false,
      Name: 'dummy name',
      PlaceId: 0,
      Source: 'https://google.com',
    },
    playingVolume: 1.0,
    firstLoad: true,
    isBuffering: false,
    isLoaded: false,
    oldStation: {
      id: 999,
    },
  },
  reducers: {
    setOldStationTo: (state, { payload }) => {
      state.oldStation = payload;
    },
    updateStation: (state, action) => {
      let copiedStation = Object.assign({}, state.currentStation);

      for (let key in state.currentStation) {
        if (key === 'PlaceId') {
          copiedStation[key] = action.payload.PlaceId ?? action.payload.PlaceId;
        } else {
          copiedStation[key] = action.payload[key];
        }
      }
      state.currentStation = copiedStation;
    },
    togglePlayStation: (state) => {
      state.currentStation.IsPlaying = !state.currentStation.IsPlaying;
    },
    updateTimeStamp: (state, action) => {
      state.currentStation.LastListened = action.payload;
    },
    toggleFavorite: (state) => {
      if (state.currentStation.favourite) {
        state.currentStation.Favourite = false;
      } else {
        state.currentStation.Favourite = true;
      }
    },
    togglePlayingState: (state) => {
      if (state.currentStation.IsPlaying) {
        state.currentStation.IsPlaying = false;
      } else {
        state.currentStation.IsPlaying = true;
      }
    },
    updateCurrentVolume: (state, action) => {
      state.playingVolume = action.payload;
    },
    muteCurrentVolume: (state) => {
      state.playingVolume = 0.0;
    },
    restoreVolume: (state, { payload }) => {
      state.playingVolume = payload;
    },
    setFavouriteTo: (state, { payload }) => {
      state.currentStation.Favorite = payload;
    },
    updateFavouriteIfToFalse: (state, { payload }) => {
      let newState = Object.assign({}, state.currentStation);
      if (newState.Id === payload.Id) {
        newState.Favorite = false;
      }
      state.currentStation = newState;
    },
    updateFavouriteIfToTrue: (state, { payload }) => {
      let newState = Object.assign({}, state.currentStation);
      if (newState.Id === payload.Id) {
        newState.Favorite = true;
      }
      state.currentStation = newState;
    },
    setPlayingToFalse: (state) => {
      state.currentStation.IsPlaying = false;
    },
    setFirstLoad: (state, { payload }) => {
      state.firstLoad = payload;
    },
    setIsBuffering: (state, { payload }) => {
      state.isBuffering = payload;
    },
    setIsLoaded: (state, { payload }) => {
      state.isLoaded = payload;
    },
  },
});

export const {
  updateStation,
  setOldStationTo,
  setFavouriteTo,
  togglePlayStation,
  updateTimeStamp,
  setIsBuffering,
  toggleFavorite,
  togglePlayingState,
  updateCurrentVolume,
  muteCurrentVolume,
  restoreVolume,
  setFirstLoad,
  updateFavouriteIfToFalse,
  updateFavouriteIfToTrue,
  setPlayingToFalse,
  setIsLoaded,
} = playerSlice.actions;

export default playerSlice.reducer;
